import { render } from "./EducationalAccords.vue?vue&type=template&id=8368e15a"
import script from "./EducationalAccords.vue?vue&type=script&lang=js"
export * from "./EducationalAccords.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__